module.exports = __webpack_public_path__ + "static/9-0ffb332ff19a304279dd8a191dce8a59.jpg";